document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.sk-policy').forEach(function(p){
    p.classList.add('sk-js');
    p.querySelectorAll('.sk-item').forEach(function(it){
      var q=it.querySelector('.sk-q'); if(!q) return;
      q.setAttribute('role','button'); q.setAttribute('tabindex','0');
      q.setAttribute('aria-expanded',it.classList.contains('open')?'true':'false');
      function t(){var o=it.classList.toggle('open');q.setAttribute('aria-expanded',o?'true':'false');}
      q.addEventListener('click',t);
      q.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();t();}});
    });
  });
});
